import { makeActionCreator } from '../../config/store/utils'

export const SET_ERROR_MODAL_SUCCESS = 'SET_ERROR_MODAL_SUCCESS'

export const onSetErrorModalSuccess = makeActionCreator(SET_ERROR_MODAL_SUCCESS, 'payload')
